import { IconName } from 'palette/Icon';
import { LogoName } from 'palette/Logo/constants';

interface SVGProps {
    ariaHidden?: boolean;
    name: IconName | LogoName;
    svgUrl: string;
    className?: string;
}

function Svg({
    ariaHidden = false,
    name,
    svgUrl,
    className,
}: SVGProps) {
    return (
        <svg
            aria-hidden={ariaHidden}
            className={className}
            role="img"
        >
            <use xlinkHref={`${svgUrl}#${name}`} />
        </svg>
    );
}

export default Svg;
